import api from '@/api/index.js'

const municipality_bot_client = {
  state: {
    updating: false,
    data: null,
    error: null,
  },

  mutations: {
    SET_MUNICIPALITY_BOT_CLIENT_UPDATING: (state, updating) => {
      state.updating = updating
    },
    SET_MUNICIPALITY_BOT_CLIENT: (state, response) => {
      state.data = response
      state.updating = false
    },
    RESTRICT_MUNICIPALITY_BOT_CLIENT: (state) => {
      state.data.secret = '***'
    },
    SET_MUNICIPALITY_BOT_CLIENT_ERROR: (state, error) => {
      state.error = error
    },
  },

  actions: {
    CreateMunicipalityBotClients({commit}, payload) {
      commit('SET_MUNICIPALITY_BOT_CLIENT', [])
      commit('SET_MUNICIPALITY_BOT_CLIENT_ERROR', null)
      commit('SET_MUNICIPALITY_BOT_CLIENT_UPDATING', true)
      return api.post(`bot-clients`, payload)
        .then((response) => {
          commit('SET_MUNICIPALITY_BOT_CLIENT', response.body)
        })
        .catch((error) => {
          commit('SET_MUNICIPALITY_BOT_CLIENT_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_MUNICIPALITY_BOT_CLIENT_UPDATING', false)
        })
    },
    HideCreatedBotClientSecret({commit}, payload) {
      commit('RESTRICT_MUNICIPALITY_BOT_CLIENT')
    },
  }
}

export default municipality_bot_client
